export interface ThemeTypes {
    colors:any,
    fonts:any,
    paddings?:any,
    margins?:any,
}

const dishStatus = {

    "IN QUEUE": {
        background:"#FCE5A9",
        text:"#3E290B"
    },

    "IN PROGRESS": {
      background:"#BBF1B9",
      text:"#47A444"
    },

    "READY": {
      background:"#C3E1C2",
      text:"#037901"
    },

    "SERVED": {
      background:"#B2E9DF",
      text:"#0D584B"
    },

    "DISCARDED": {
      background:"#F8C2C2",
      text:"#890707"
    },

    "ABORTED": {
      background:"#F8C2C2",
      text:"#890707"
    },

    "CANCELED": {
      background:"#F8C2C2",
      text:"#890707"
    },

};

const card = {
  background:'#E7DBC5',
  primaryText:'',
  secondaryText:'',
  boxShadow:'',
  border:''
}

const main = {
  primary:"",
  secondary:"",
  tertiary:"",
  background:'#282828',
  text:'#FFFFFF',
  primaryText:"#FFFFFF",
  secondaryText:"#998765",
  tertiaryText:"",
}

const button = {
  background:"#622426",
  text:"#FFF"
}

const misc = {
  rating:{
    fill:"#fd4",
    border:"#998765"
  }
}

const fonts = {
  primary:"Roboto",
  secondary:"Actor",
  tertiary:"Poppins",
  fallback:"sans-serif",
}

const paddings = {
    pagePadding:''
}

export const colors = { main, button, card, dishStatus, misc };

export const theme:ThemeTypes = { colors, fonts, paddings };